const angular = require('angular');

const OrderManagementService = require('./ordermanagement.service');


angular.module('wowApp.shop')
    .service('OrderManagementService', ['Restangular', 'BreakpointsService', OrderManagementService]);



// WEBPACK FOOTER //
// ./src/order/ordermanagement/index.js